import { trackEvent } from '@raisin/events-tracking';
import { CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES, CUSTOMER_PORTAL_COMPONENT } from '../constants';
import { CustomerPortalEvent } from '../types';
import { getAuthValue, guardDistributorValue } from '../utils';
import { onHeroCtaClickedEventProps } from './types';

const createHeroCtaClickedEvent = ({
  distributorId,
  isLoggedIn,
}: onHeroCtaClickedEventProps): CustomerPortalEvent => ({
  ...CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
  eventName: 'cta_clicked',
  object: 'cta',
  action: 'clicked',
  component: CUSTOMER_PORTAL_COMPONENT.HERO,
  customerGroup: guardDistributorValue(distributorId),
  customAttribute1: getAuthValue(isLoggedIn),
});

export const onTrackHeroCtaClicked = ({ distributorId, isLoggedIn }: onHeroCtaClickedEventProps) =>
  trackEvent(
    createHeroCtaClickedEvent({
      distributorId,
      isLoggedIn,
    }),
  );
